module.exports = __webpack_public_path__ + "static/media/vg.403e9dca.webp";